// extracted by mini-css-extract-plugin
export default {"search":"Search_search__JtbP4","search-input":"Search_search-input__kE1Ma"};